import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import BecomeAgentBanner from "../component/BecomeAgentBanner";
import CreateAccountCTA from "../component/CreateAccountCTA";
import { Col, Container, Row } from "react-bootstrap";
import BecomeAgentImage1 from "../assets/images/become-agent-img-1.png";
import BecomeAgentImage2 from "../assets/images/become-agent-img-1.png";
import BecomeAgentImage3 from "../assets/images/become-agent-img-1.png";
import BecomeAgentIcon1 from "../assets/images/become-agent-icon-1.svg";
import BecomeAgentIcon2 from "../assets/images/become-agent-icon-2.svg";
import BecomeAgentIcon3 from "../assets/images/become-agent-icon-3.svg";
function BecomeAgent() {
  return (
    <>
      <div className="main become-agent-page">
        <Header />
        <BecomeAgentBanner />
        <div className="become-agent-content common-padding">
          <Container>
            <Row className="row-gap-100 align-items-center">
              <Col md={12} lg={6}>
                <div className="become-agent-img">
                  <img src={BecomeAgentImage1} alt="Become an Agent" />
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="become-agent-text pl-25">
                  <div className="become-agent-icon">
                    <img src={BecomeAgentIcon1} alt="" />
                  </div>
                  <h2>
                    Stand out with a <span>strong profile</span>
                  </h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged. It was popularised in the 1960s with
                    the release of Letraset sheets containing Lorem Ipsum
                    passages, and more recently with desktop publishing software
                    like Aldus PageMaker including versions of Lorem Ipsum.
                  </p>
                </div>
              </Col>
              <Col md={12} lg={6} className="order-2 order-lg-0">
                <div className="become-agent-text pr-25">
                  <div className="become-agent-icon">
                    <img src={BecomeAgentIcon2} alt="" />
                  </div>
                  <h2>
                    Showcase your <span>listings</span>
                  </h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged. It was popularised in the 1960s with
                    the release of Letraset sheets containing Lorem Ipsum
                    passages, and more recently with desktop publishing software
                    like Aldus PageMaker including versions of Lorem Ipsum.
                  </p>
                </div>
              </Col>
              <Col md={12} lg={6} className="order-1 order-lg-0">
                <div className="become-agent-img">
                  <img src={BecomeAgentImage2} alt="Become an Agent" />
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="become-agent-img">
                  <img src={BecomeAgentImage3} alt="Become an Agent" />
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="become-agent-text pl-25">
                  <div className="become-agent-icon">
                    <img src={BecomeAgentIcon3} alt="" />
                  </div>
                  <h2>
                    Leverage <span>your team</span>
                  </h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged. It was popularised in the 1960s with
                    the release of Letraset sheets containing Lorem Ipsum
                    passages, and more recently with desktop publishing software
                    like Aldus PageMaker including versions of Lorem Ipsum.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <CreateAccountCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default BecomeAgent;
